export interface TemperatureMessage {
    icon: number;
    temperature: number;
}

export const initialTemperatureState: TemperatureMessage = {
    icon: 0,
    temperature: 0,
};
